// extracted by mini-css-extract-plugin
module.exports = {"currencyBox":"CurrencyComponentV2_currencyBox__11Km_","container":"CurrencyComponentV2_container__3hl5n"};